import { createFileRoute, redirect } from "@tanstack/react-router";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/de/create-listing/")({
  head: () => routeHead("/de/create-listing/"),
  beforeLoad: () => {
    throw redirect({ href: "/de/create-listing-v2", statusCode: 301, replace: true });
  },
});
